//import Vue from 'vue'

const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
    async save (context, data) {
        const response = await axios.post('/api/v1/profile/', data)
            .catch(error => error.response || null)
            return response
    },
//    async destroy (context, data) {
//        const response = await axios.delete('/api/v1/pages/' + data.page_id + '/messages/' + data.id)
//            .catch(error => error.response || null)
//            return response
//    },
//    async index (context, data) {
//        const response = await axios.get('/api/v1/pages/' + data.page_id + '/messages' + (data.id ? '/' + data.id : ''), {
//            params: (typeof data === 'object' && !data.id ? data : null)
//        })
//        .catch(error => error.response || null)
//            return response
//    },
//    async like (context, data) {
//        const response = await axios.put('/api/v1/customers/' + data.id + '/like/' + (data.like ? 1 : 0))
//            .catch(error => error.response || null)
//            return response
//    },
//    async contact (context, data) {
//        const response = await axios.post('/api/v1/customers/' + data.id + '/contact', data)
//            .catch(error => error.response || null)
//
//            ga('send', {
//                hitType: 'event',
//                eventCategory: 'item',
//                eventAction: 'contact',
//                eventLabel: data.id,
//            })
//        return response
//    },
//    async status (context, data) {
//        const response = await axios.put('/api/v1/customers/' + data.id + '/status', data)
//            .catch(error => error.response || null)
//            return response
//    },
//    async download (context, data) {
//        data = Object.assign(data, { download: true, })
//            const response = await axios.get('/api/v1/customers', {
//                params: (typeof data === 'object' ? data : null),
//                responseType: 'blob',
//                dataType: 'binary',
//                headers: { 'Cache-Control': 'no-cache' },
//            })
//        .catch(error => error.response || null)
//            Vue.prototype.download(response)
//            return response
//    },
//    //  async logout (context, data) {
//    //    const response = await axios.get('/api/v1/auth/logout', data).catch(error => error.response || null)
//    //    context.commit('setUser', null)
//    //    return response
//    //  },
//    //  async signup (context, data) {
//    //    const response = await axios.post('/api/v1/auth/signup', data).catch(error => error.response || null)
//    //    context.commit('setUser', response.data)
//    //    return response
//    //  },
//    //  async me (context) {
//    //    const response = await axios.get('/api/v1/auth/me').catch(error => error.response || null)
//    //    context.commit('setUser', response.data)
//    //    return response
//    //  }
//    async syncCustomers (context, page_id) {
//        const response = await axios.get('/api/v1/customers/' + page_id + '/sync-customers', {
//        })
//            .catch(error => error.response || null)
////        this._vm.$set(context.state.user, 'customers', response.data || []);
//        return response
//    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}


